<template>
  <b-card class="">
    <div
      class="partner-img card-img-top rounded-circle cursor-pointer"
      @click="handleToStore"
      v-bind:style="{
        backgroundImage: 'url(' + data.imageUrl + ')'
      }"
    ></div>
    <b-card-body class="text-center">
      <h4 class="card-text cursor-pointer" @click="handleToStore">
        {{ data.name }}
      </h4>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  name: "PartnerPanelCard",
  props: {
    data: {
      required: true,
      type: Object
    }
  },
  methods: {
    handleToStore: async function () {
      await this.$cookies.remove("adminSellerId");
      await this.$cookies.set(
        "adminSellerId",
        this.data.id,
        60 * 60 * 24 * 365,
        "/",
        this.$cookiesDomain
      );
      this.$router.push({ path: `/product` });
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  border: none;
  width: 100%;
}

::v-deep .card-body {
  padding: 0 5px !important;
}

.card-text {
  font-size: 22px;
  margin: 10px 0px 0px 0px;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  height: 42px;
  line-height: 1;
}

.partner-img {
  width: 100%;
  padding-bottom: 100%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.partner-img {
  width: 100%;
  padding-bottom: 100%;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 50%;
}
.partner-img:hover {
  box-shadow: 0px 0px 6px grey !important;
}
.card-text:hover {
  text-decoration: underline !important;
}
.cursor-pointer {
  cursor: pointer;
}
@media (max-width: 767.98px) {
  .card-text {
    font-size: 20px;
    height: 40px;
    margin-bottom: 8px;
  }
}
</style>
